import React from "react";
import {
    useTable,
    usePagination,
    useSortBy,
} from "react-table";
import { getCellAlignProps } from "../../../../utils/helper";

const Paginated = ({ columns, data }) => {

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 10 },
        },
        useSortBy,
        usePagination
    );

    return (
        <div className="customTable">
            <div className="customTable__header">
                <div className="customTable__left">
                    <div className="customTable__showingRecords">
                        <div className="form-group">
                            <label>Show Records:</label>

                            <select
                                className="form-control selectArrow"
                                value={pageSize}
                                onChange={(e) => setPageSize(Number(e.target.value))}
                            >
                                {[10, 25, 50, 100].map((size) => (
                                    <option key={size} value={size}>
                                        {size}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="customTable__body">
                <div className="table-responsive">
                    <table
                        className="table table-striped table-bordered"
                        {...getTableProps()}
                    >
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        {page?.length ? (
                            <tbody {...getTableBodyProps()}>
                                {page.map((row, i) => {
                                    prepareRow(row);

                                    return (
                                        <tr {...row.getRowProps()} key={i}>
                                            {row.cells.map((cell) => (
                                                <td {...getCellAlignProps(cell)}>
                                                    {cell.render("Cell")}
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={12}>
                                        <p style={{ textAlign: "center", margin: 0 }}>
                                            No data found
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>

            <div className="customTable__footer">
                <div className="customTable__left">
                    <div className="customTable__totalTransactions">
                        <p>
                            Total Records: <span>{data?.length || 0}</span>
                        </p>
                    </div>
                </div>

                <div className="customTable__right">
                    <div className="customTable__top">
                        <div className="customTable__totalPages">
                            <p>
                                Page

                                <select
                                    className="form-control selectArrow"
                                    value={pageIndex + 1}
                                    onChange={(e) => gotoPage(Number(e.target.value) - 1)}
                                >
                                    {[...Array(pageOptions.length || 1)].map((_, index) => (
                                        <option key={index + 1} value={index + 1}>
                                            {index + 1}
                                        </option>
                                    ))}
                                </select>

                                of <span>{pageOptions.length || 1}</span>
                            </p>
                        </div>
                    </div>

                    <div className="customTable__bottom customTable__bottom__2">
                        <div className="customTable__buttons">

                            <span
                                className={`btn btn-outline-primary ${!canPreviousPage ? "disabled" : ""
                                    }`}
                                onClick={() => previousPage()}
                            >
                                Previous
                            </span>

                            <span
                                className={`btn btn-outline-primary ${!canNextPage ? "disabled" : ""
                                    }`}
                                onClick={() => nextPage()}
                            >
                                Next
                            </span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Paginated;
